import { Component, OnInit } from '@angular/core';
import { AuthorisedSideNavService } from '../../../layout/authorised/services/authorised-side-nav.service';
import { FormBuilder,FormControl, Validators ,FormGroup,FormArray } from '@angular/forms';
import { ClientServiceService } from "../../../shared/client-service.service";
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import * as moment from 'moment';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  per_page:number=10;
  current_page:number=1;
  total_orders:number=0;
  total_pages:number=0;
  start_date='';
  end_date='';
  format="YYYY-MM-DD";
  ordersData:any;
  is_orders_loading=false;
  is_orders_loaded=false;
  public paginationRange=9;
  public previousLabel:string="Previous";
  public nextLabel:string="Next";
  public screenReaderPaginationLabel:string="Pagination";
  public screenReaderPageLabel:string="page";
  public screenReaderCurrentLabel:string="You're on page";
  public nextpage=2;
  public previouspage=0;
  public pages:any[]=[];
  public orderlistck:any[]=[];
  public checkedOrderList:any[] = [];
  public per_values:any[]=[10,20,25,50,100];
  isMasterSel:boolean;

  public sales_email: string;
  
  searchForm = new FormGroup({

  	start_date: new FormControl('', Validators.required),
  	end_date: new FormControl('', Validators.required)
  });
  
    delForm = new FormGroup({

	checkArray: new FormArray([], [Validators.required]),
	
  });
  constructor(public sideNavService: AuthorisedSideNavService,private formBuilder: FormBuilder,public restApi: ClientServiceService) { }

  ngOnInit(): void 
  {
    this.load_orders();
  }
  submitdelForm()
  {
    this.checkedOrderList = [];
    for (var i = 0; i < this.orderlistck.length; i++) 
    {
      if(this.orderlistck[i].checked)
        this.checkedOrderList.push(this.orderlistck[i].value);
    }
  	if(this.checkedOrderList.length==0)
  	{
    	alert("Please Select Orders to Delete");
    	return false;
  	}
  	else
  	{
 
      var ordersstr = this.checkedOrderList.join();
      var r = confirm("Are you sure to delete the orders "+ordersstr);
      if (r == true) 
      {

        console.log(this.checkedOrderList);
       var self=this;
         this.restApi.SubmitDeleteForm(this.checkedOrderList).subscribe(data =>{
         self.current_page=1;
         self.load_orders();
         })
      } 
      else 
      {
        return false;
      }
    }
  }
  checkUncheckAll() {
    for (var i = 0; i < this.orderlistck.length; i++) {
      this.orderlistck[i].checked = this.isMasterSel;
    }
    
  }
  onCheckboxChange(e)
  {
    const checkArray: FormArray = this.delForm.get('checkArray') as FormArray;

    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: FormControl) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  
  }
  onCheckboxChangeSelectAll(e)
  {
    this.delForm = new FormGroup({

	  checkArray: new FormArray([], [Validators.required]),
  });
  
  }
  searchsubmit()
  {
    this.current_page=1;
    this.start_date=moment(this.searchForm.value.start_date).format(this.format);
    this.end_date=moment(this.searchForm.value.end_date).format(this.format);
    this.load_orders();
  }

  load_orders()
  {
    let currentUser = JSON.parse(localStorage.getItem('seocurrentUser'));
    console.log();
    this.is_orders_loading=true;
    this.nextpage= this.current_page+1;
    this.previouspage=this.current_page-1;
    this.restApi.getVendorOrders(currentUser['email'], this.per_page, this.current_page, this.start_date, this.end_date).subscribe(data =>{
    	this.ordersData=data.orders;
    	this.orderlistck=[];
    	this.isMasterSel=false;
      if (this.ordersData && this.ordersData.length > 0)
      {
        for(var i=0;i<this.ordersData.length;i++)
        {
          this.orderlistck.push({ value:this.ordersData[i].id,  checked: false });
        }
      }
    	
    	this.total_orders=data.total;
    	this.createPageArray(this.current_page, this.per_page, this.total_orders, this.paginationRange)
    	this.total_pages=data.pages;
    	this.is_orders_loading=false;
    	this.is_orders_loaded=true;
    	console.log(data);

  	})
  }
  
  
  ChangePage(page:number): void {
    this.current_page=page;
   this.load_orders();
  }
  onperpageSelected(perpage)
  {
  this.current_page=1;
  this.per_page=perpage;
   this.load_orders();
  }
   isFirstPage(): boolean {
        return this.getCurrent() === 1;
    }
	  isLastPage(): boolean {
        return this.getLastPage() === this.getCurrent();
    }
	setCurrent(page: number) {
        this.ChangePage(page);
    }

    /**
     * Get the current page number.
     */
    getCurrent(): number {
        return this.current_page;
    }
	 getLastPage(): number {
       
        if (this.total_orders < 1) {
            // when there are 0 or fewer (an error case) items, there are no "pages" as such,
            // but it makes sense to consider a single, empty page as the last page.
            return 1;
        }
        return Math.ceil(this.total_orders / this.per_page);
    }

    getTotalItems(): number {
        return this.total_orders;
    }
	
	previous() {
       
        this.setCurrent(this.getCurrent() - 1);
    }

    /**
     * Go to the next page
     */
    next() {
       
        this.setCurrent(this.getCurrent() + 1);
    }
  
	public createPageArray(currentPage: number, itemsPerPage: number, totalItems: number, paginationRange: number) {
        // paginationRange could be a string if passed from attribute, so cast to number.
        paginationRange = +paginationRange;
        let pages = [];
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        const halfWay = Math.ceil(paginationRange / 2);

        const isStart = currentPage <= halfWay;
        const isEnd = totalPages - halfWay < currentPage;
        const isMiddle = !isStart && !isEnd;

        let ellipsesNeeded = paginationRange < totalPages;
        let i = 1;

        while (i <= totalPages && i <= paginationRange) {
            let label;
            let pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
            let openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
            let closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                label = '...';
            } else {
                label = pageNumber;
            }
            pages.push({
                label: label,
                value: pageNumber
            });
            i ++;
        }
        this.pages=pages;
    }

    /**
     * Given the position in the sequence of pagination links [i],
     * figure out what page number corresponds to that position.
     */
    private calculatePageNumber(i: number, currentPage: number, paginationRange: number, totalPages: number) {
        let halfWay = Math.ceil(paginationRange / 2);
        if (i === paginationRange) {
            return totalPages;
        } else if (i === 1) {
            return i;
        } else if (paginationRange < totalPages) {
            if (totalPages - halfWay < currentPage) {
                return totalPages - paginationRange + i;
            } else if (halfWay < currentPage) {
                return currentPage - halfWay + i;
            } else {
                return i;
            }
        } else {
            return i;
        }
    }

}
